import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getCartInfoByHashId, syncLocalCartToAPI } from "../../services/cart";
import { toast } from "react-toastify";

export default function CartHash({ history, match }) {
  const signed = useSelector((state) => state.auth.signed);
  const user = useSelector((state) => state.user.profile);
  const hashIdCart = match.params.hashId;

  useEffect(() => {
    const checkCart = async () => {
      try {
        if (hashIdCart) {
          const cartInfo = await getCartInfoByHashId(hashIdCart);

          if (cartInfo && cartInfo.cliente) {
            if (signed && user && cartInfo.cliente.uuid === user.uuid) {
              await syncLocalCartToAPI(cartInfo.cliente.uuid, hashIdCart);
              history.replace("/carrinho");
              return;
            } else if (!signed) {
              // Se não estiver logado, verifica se o cliente possui um UUID ou ID
              // Se tiver UUID, significa que já é um cliente completo e ai basta redirecionar para entrar
              // Se não tiver UUID mas tem ID, significa que foi cadastro via venda assistida, não é um cliente completo, então redireciona para concluir o cadastro
              if (cartInfo.cliente.uuid) {
                return history.replace("/entrar", {
                  previousPage: history.location.pathname,
                });
              } else if (cartInfo.cliente.id) {
                return history.replace("/criar-conta", {
                  customer: {
                    cpf: cartInfo.cliente.cpf,
                    nome: cartInfo.cliente.nome,
                    email: cartInfo.cliente.email,
                    celular: cartInfo.cliente.celular,
                  },
                });
              }
            }
          }
        }

        toast.error(
          "Cesta não existe ou você não tem permissão para acessá-lo.",
          {
            autoClose: 5000,
          }
        );
        history.replace("/");
      } catch (e) {
        toast.error("Erro ao obter dados da cesta: " + e);
      }
    };

    checkCart();
  }, [hashIdCart, history]);

  return null;
}
